import EN from '@rendora/common/locales/en-US.json';
import CHS from '@rendora/common/locales/zh-CN.json';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { createPinia } from 'pinia';
import { COOKIE_KEY } from '~/constants/config';
import { PageKey } from '~/constants/page';
import { SAFE_HOST } from '~/utils/constant';

const pinia = createPinia();

import { createI18nService } from '@rendora/common/services/i18n/index';
import { initStoreService } from '@rendora/common/services/store';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

export default defineNuxtPlugin(async ({ vueApp }) => {
  const requestURL = useRequestURL();
  const runtimeConfig = useRuntimeConfig();
  const route = useRoute();

  // 2. 初始化安全域名检测
  if (
    !runtimeConfig.public.privatization &&
    runtimeConfig.public.env === 'production' &&
    process.env.NODE_ENV === 'production' &&
    !SAFE_HOST.some(item => item.test(requestURL.host)) &&
    route.name !== PageKey.NOT_FOUND
  ) {
    navigateTo('/not-found');
    return {};
  }

  // 3. 初始化时区信息
  const timezone = useCookie(COOKIE_KEY.TIMEZONE).value || 'Asia/Shanghai';
  dayjs.tz.setDefault(timezone);
  if (import.meta.client) {
    setCookie(COOKIE_KEY.TIMEZONE, dayjs.tz.guess());
  }

  const i18nSrv = createI18nService({
    legacy: false,
    globalInjection: true,
    defaultLocale: isChinese() ? 'zh-CN' : 'en-US',
    messages: {
      'zh-CN': CHS,
      'en-US': EN,
    },
  });

  await i18nSrv.initialize(vueApp);

  vueApp.use(pinia);
  initStoreService();

  useHead({
    htmlAttrs: {
      lang: getDefaultLocale(),
    },
    script: [
      {
        src: `${runtimeConfig.app.cdnURL}/libs/qrcode.js`,
        defer: true,
      },
      {
        src: `${runtimeConfig.app.cdnURL}/lib-pag/libpag.min.js`,
        defer: true,
      },
    ],
  });

  return {
    provide: {
      t: i18nSrv.getI18n().global.t,
      dayjs,
    },
  };
});
